import { useEffect, useState } from 'react';
export const Section = ({
  active,
  lazy,
  children
}) => {
  const [canMount, setCanMount] = useState(!lazy);
  useEffect(() => {
    if (!canMount && active) {
      setCanMount(true);
    }
  }, [canMount, active]);
  return canMount && children;
};